<template>
  <div class="signs-features">
    <section class="signs-features__features" aria-labelledby="firma-escrituras-features-title">
      <header>
        <h2 id="firma-escrituras-features-title"><span>Características</span> generales</h2>
        <p>Lo que incluye este momento clave</p>
      </header>

      <div class="signs-features__list">
        <article v-for="feature in features" :key="feature" class="signs-features__item">
          <img :src="checkIcon" alt="" aria-hidden="true">
          <p>{{ feature }}</p>
        </article>
      </div>
    </section>

    <section class="signs-features__help" aria-labelledby="firma-escrituras-help-title">
      <h2 id="firma-escrituras-help-title">¿Cómo te ayuda <span>la firma de escritura</span>?</h2>
      <p>
        Te brinda el respaldo absoluto y la certeza jurídica para convertirte en propietario, asegurando que disfrutes plenamente de tu patrimonio con la guía y tranquilidad de estar acompañado por expertos en cada paso.
      </p>
    </section>
  </div>
</template>

<script setup lang="ts">
import checkIcon from '../../../assets/firma-escrituras/icon-check.svg'

const features = [
  'Atención personalizada y adaptada a tus necesidades con un equipo de asesores a tu lado.',
  'Programación y confirmación de cita a través de tu medio de contacto preferido (correo electrónico, llamada telefónica o mensaje de texto).',
  'Entrega inmediata del comprobante de pago correspondiente al trámite una vez firmada la escritura.'
]
</script>

<style scoped>
.signs-features { display: flex; flex-direction: column; gap: 40px; }
.signs-features h2 { margin: 0; color: var(--ds-purple-900); font-family: var(--ds-font-family-bebas); font-size: 40px; line-height: 44px; font-weight: 700; }
.signs-features h2 span { color: var(--ds-purple-400); }
.signs-features p { margin: 0; color: var(--ds-text-primary); font-size: var(--ds-body3-size); line-height: 24px; }
.signs-features__features { display: flex; flex-direction: column; gap: 32px; }
.signs-features__features header { display: flex; flex-direction: column; gap: 8px; }
.signs-features__list { display: flex; flex-direction: column; gap: 16px; }
.signs-features__item { display: flex; align-items: center; gap: 16px; padding: 16px; border-radius: 16px; background: var(--ds-grey-50); }
.signs-features__item img { width: 24px; height: 24px; object-fit: contain; }
.signs-features__help { display: flex; flex-direction: column; gap: 24px; padding: 24px 16px; border: 1px solid #c1d7f9; border-radius: 24px; background: var(--ds-border-primary); }
.signs-features__help h2 { font-size: 40px; line-height: 38px; }

@media (min-width: 768px) {
  .signs-features__item { height: 100%; box-sizing: border-box; }
  .signs-features__help { padding: 32px; }
}
</style>
